var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "alternate-form" } },
    [
      _vm.brokenPage
        ? [
            _c("h3", [_vm._v("Sorry, we have encountered an error.")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("It appears that the url you have used is incomplete."),
            ]),
          ]
        : [
            _vm.theForm === "nomination"
              ? _c("NominationForm", {
                  attrs: { credentials: _vm.credentials },
                })
              : _vm.theForm === "confirmation"
              ? _c("AcceptanceForm", {
                  attrs: { credentials: _vm.credentials },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }